<template>
  <div
    class="c-app flex-row align-items-center"
    :class="{ 'c-dark-theme': $store.state.darkMode }"
  >
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
             <CCard
              color="primary"
              text-color="white"
              class="text-center py-5 d-md-down-none"
              body-wrapper
            >
              <CCardBody>
                <h2>Siren Warning System</h2>
                <h3>Mode Normal</h3>
                <p>01/02/2021 10:00 AM</p>
                <!-- <CButton
                  color="light"
                  variant="outline"
                  size="lg"
                >
                  Register Now!
                </CButton> -->
              </CCardBody>
            </CCard>
            <CCard class="p-4">
              <CCardHeader>Refresh / Network Status</CCardHeader>
              <CCardBody>
                <CForm>
                  <CInput
                    label="Station"
                    value="Kg. Gajah"
                    horizontal
                    plaintext
                  />
                  <CInput
                    label="Mode"
                    value="Normal"
                    horizontal
                    plaintext
                  />
                  <CInput
                    label="Network"
                    value="Connected"
                    horizontal
                    plaintext
                  />
                </CForm>
              </CCardBody>
              <CCardFooter>Login</CCardFooter>
            </CCard>
           
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: "Landing",
};
</script>
